import { Loading } from "api/wms/models";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { TypographyProps } from "components/miloDesignSystem/atoms/typography/types";
import { format, isToday, isYesterday } from "date-fns";
import { dateFns } from "utilities";

interface Props {
  fontSize: TypographyProps["fontSize"];
  fontWeight: TypographyProps["fontWeight"];
  loading: Loading;
}

export const LoadingFinish = ({ fontSize, fontWeight, loading }: Props) => {
  if (!loading.finishedAt)
    return (
      <Typography fontSize={fontSize} fontWeight={fontWeight}>
        ---
      </Typography>
    );

  if (loading.finishedAt) {
    if (isToday(new Date(loading.finishedAt))) {
      return (
        <Typography fontSize={fontSize} fontWeight={fontWeight}>
          {format(new Date(loading.finishedAt), "H:mm")}
        </Typography>
      );
    }
    if (isYesterday(new Date(loading.finishedAt))) {
      return (
        <Typography fontSize={fontSize} fontWeight={fontWeight}>
          wczoraj, {dateFns.format(new Date(loading.finishedAt), "H:mm")}
        </Typography>
      );
    }
    return (
      <Typography fontSize={fontSize} fontWeight={fontWeight}>
        {dateFns.format(new Date(loading.finishedAt), "d.MM.yyyy")}
      </Typography>
    );
  }

  return null;
};
